module.exports = __webpack_public_path__ + "public/images/slider/Muradyan.2ca1a67b0a0848d4036688d23d1f58f8.webp";